import { render, staticRenderFns } from "./AddSale.vue?vue&type=template&id=39be3162&scoped=true&"
import script from "./AddSale.vue?vue&type=script&lang=js&"
export * from "./AddSale.vue?vue&type=script&lang=js&"
import style0 from "./AddSale.vue?vue&type=style&index=0&id=39be3162&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39be3162",
  null
  
)

export default component.exports